var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60682 6.10416C2.56485 6.10275 2.52362 6.09278 2.48565 6.07487C2.44768 6.05696 2.41376 6.03148 2.38598 6L0.30265 3.91666C0.262928 3.89091 0.229577 3.85647 0.205114 3.81594C0.180651 3.77541 0.165716 3.72985 0.161436 3.68271C0.157156 3.63556 0.163644 3.58806 0.180409 3.54379C0.197173 3.49951 0.223778 3.45963 0.258212 3.42714C0.292647 3.39466 0.334012 3.37042 0.379185 3.35626C0.424358 3.3421 0.472157 3.33839 0.518974 3.34541C0.565791 3.35242 0.610403 3.36998 0.649439 3.39676C0.688476 3.42354 0.720919 3.45884 0.744317 3.5L2.60682 5.35L6.96932 0.999997C7.02805 0.961918 7.09786 0.944659 7.16757 0.950987C7.23728 0.957315 7.30285 0.986864 7.35377 1.0349C7.40468 1.08293 7.438 1.14667 7.44837 1.21589C7.45875 1.28511 7.44558 1.35581 7.41098 1.41666L2.82765 6C2.79987 6.03148 2.76596 6.05696 2.72798 6.07487C2.69001 6.09278 2.64878 6.10275 2.60682 6.10416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.53a8f377f68a00dbd436bfb29aad1490.svg";
export { ForwardRef as ReactComponent };